export const LOW_TO_HIGH = "LOW_TO_HIGH"
export const HIGH_TO_LOW = "HIGH_TO_LOW"
